(function () {
  'use strict';

  if (window.Shopify && Shopify.designMode) return; // no-op inside the theme editor (block-selection guard)

  var BAG_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  var COLOR_MAP = {
    black:'#000',white:'#fff',red:'#e53935',blue:'#1565c0',navy:'#0d1b4b',
    green:'#2e7d32',grey:'#888',gray:'#888',pink:'#f06292',beige:'#f5f0e8',
    brown:'#6d4c41',yellow:'#fdd835',orange:'#f4511e',purple:'#6a1b9a',
    camel:'#c19a6b',cream:'#fffdd0',khaki:'#c3b091',olive:'#558b2f',
    maroon:'#880e4f',coral:'#ff6b6b',mint:'#80cbc4',lavender:'#ce93d8',
    charcoal:'#455a64',teal:'#00897b',sand:'#c2b280',stone:'#928e85',
    ivory:'#fffff0','light grey':'#d3d3d3','dark grey':'#455a64',
    'off white':'#f8f5f0','powder pink':'#f9c5d1','baby blue':'#aed6f1',
    nude:'#e8c5a5',burgundy:'#800020',wine:'#722f37',slate:'#708090',
    taupe:'#b5a99a',lilac:'#c8a2c8',mustard:'#e1ad01',rust:'#b7410e'
  };

  function getCfg() {
    try { var el = document.getElementById('qcd-config'); return el ? JSON.parse(el.textContent) : {}; }
    catch (e) { return {}; }
  }

  function money(cents, fmt) {
    if (cents == null) return '';
    var n = (cents / 100).toFixed(2);
    var ni = String(Math.round(cents / 100));
    return (fmt || '{{amount}}')
      .replace('{{amount}}', n)
      .replace('{{amount_no_decimals}}', ni)
      .replace('{{amount_with_comma_separator}}', n.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', ni);
  }

  function esc(s) { return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }

  function thumb(src, size) {
    if (!src) return '';
    return src.split('?')[0].replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  // Product handle out of any /products/... url or path. Tolerates absolute urls,
  // query strings (search suggest returns ?_pos=&_psq=), hashes and trailing slashes.
  function hOf(u) {
    if (!u) return '';
    var s = String(u).split('#')[0].split('?')[0];
    var i = s.indexOf('/products/');
    if (i === -1) return '';
    return s.slice(i + 10).split('/')[0];
  }

  function buildOWV(product) {
    return (product.options || []).map(function (opt, idx) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var key = 'option' + (idx + 1), seen = [], values = [];
      product.variants.forEach(function (v) {
        if (v[key] && seen.indexOf(v[key]) === -1) { seen.push(v[key]); values.push(v[key]); }
      });
      return { name: name, values: values };
    });
  }

  if (!customElements.get('quick-cart-drawer')) {
    class QuickCartDrawer extends HTMLElement {
      connectedCallback() {
        this._cfg = getCfg();
        this._product = null;
        this._owv = [];
        this._sel = [];
        this._group = [];
        this._pcache = {}; // handle -> parsed /products/{h}.js JSON (warm-on-open sibling prefetch)
        this._cardImgs = {}; // handle -> featured image, harvested from the opened card
        this.toggleState = false;
        this._main = this.querySelector('.quick-cart-drawer__main');
        this._panel = this.querySelector('.quick-cart-drawer__blocks');

        var closeBtn = this.querySelector('.button--close');
        var backdrop = this.querySelector('.quick-cart-drawer__backdrop');
        if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this), { passive: true });
        if (backdrop) backdrop.addEventListener('click', this.close.bind(this), { passive: true });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); }, { passive: true });

        this._wireTriggers();
        this._wireSwatchWarm();
        this._wireMain();
      }

      // ONE delegated click listener on .quick-cart-drawer__main, which is never itself
      // replaced (only its innerHTML is). Previously every render re-attached listeners to
      // freshly created buttons; combined with the innerHTML rebuilds below that made fast
      // taps unreliable. Delegation means a tap always finds a handler no matter what just
      // re-rendered. Bound once, in connectedCallback.
      _wireMain() {
        var self = this;
        if (!this._main || this._mainWired) return;
        this._mainWired = true;
        this._main.addEventListener('click', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('.qcd-add')) { self._addToCart(); return; }
          var sw = t.closest('.qcd-swatch[data-url]');
          if (sw) { self._pickColor(sw); return; }
          var opt = t.closest('[data-i]');
          if (opt) {
            // Out-of-stock values stay selectable, exactly as before: selecting one flips the
            // CTA to Notify me rather than doing nothing.
            self._sel[+opt.getAttribute('data-i')] = opt.getAttribute('data-v');
            self._refresh();
          }
        });
      }

      // A colour swatch tap. Applies the selection OPTIMISTICALLY (ring + name + the group's
      // own active flag) so the UI answers on the same frame as the tap, then loads the
      // sibling product behind it.
      _pickColor(btn) {
        var container = this._main.querySelector('.qcd-opts');
        var h = btn.getAttribute('data-h');
        var lbl = (btn.getAttribute('data-label') || '').trim();
        // Only overwrite the name when the swatch carries a real (non-empty) label, else the
        // name would flash blank until the sibling JSON lands and recomputes it.
        var nameEl = container && container.querySelector('.qcd-color-name');
        if (nameEl && lbl) { nameEl.textContent = lbl; }
        (this._group || []).forEach(function (g) { g.active = g.handle === h; });
        if (container) {
          container.querySelectorAll('.qcd-swatch[data-url]').forEach(function (s) {
            s.classList.toggle('sel', s === btn);
          });
        }
        this._loadUrl(btn.getAttribute('data-url'));
      }

      // Colour switching ON THE CARD costs the app one Storefront GraphQL call (~250ms
      // cold, ~6ms warm) PLUS the sibling's full-size photo (~350ms on a phone) -- and the
      // photo is the part the shopper actually watches. The app already names every
      // sibling image in a hidden per-card block, so warm them the moment a pointer or
      // finger reaches the card. By the time the tap resolves the bitmap is decoded and
      // the swap paints immediately. Once per card, passive, never on the click path.
      _wireSwatchWarm() {
        var seen = (typeof WeakSet === 'function') ? new WeakSet() : null;
        function warm(e) {
          var t = e.target;
          if (!t || !t.closest) return;
          var card = t.closest('product-card, .card-product, .product-card');
          if (!card) return;
          if (seen) { if (seen.has(card)) return; seen.add(card); }
          else { if (card.hasAttribute('data-qcd-warm')) return; card.setAttribute('data-qcd-warm', '1'); }
          card.querySelectorAll('[data-featured-image]').forEach(function (el) {
            var src = el.getAttribute('data-featured-image');
            if (!src) return;
            var im = new Image();
            try { im.fetchPriority = 'low'; } catch (e2) {}
            im.decoding = 'async';
            im.src = src;
          });
        }
        document.addEventListener('pointerover', warm, { passive: true });
        document.addEventListener('touchstart', warm, { passive: true });
      }

      // INP: one rAF-coalesced document.body observer instead of two unthrottled ones. The old code
      // ran two full-document querySelectorAll scans on EVERY mutation batch (e.g. every SA-Variants
      // swatch inject + lazy-image swap while scrolling a collection) = pre-paint work on the hottest
      // pages. Now: bind the click AND inject the bag icon in one pass under a single data-qcd flag,
      // skip mutation batches that added no element nodes, and do at most one scan per animation frame.
      _wireTriggers() {
        var self = this;
        function process() {
          document.querySelectorAll('.quick-cart-drawer__trigger:not([data-qcd])').forEach(function (btn) {
            btn.setAttribute('data-qcd', '1');
            var sp = document.createElement('span');
            sp.className = 'qcd-bag-icon';
            sp.setAttribute('aria-hidden', 'true');
            sp.innerHTML = BAG_SVG;
            btn.prepend(sp);
            btn.addEventListener('click', function () { self._load(btn); });
          });
        }
        process();
        var scheduled = false;
        new MutationObserver(function (muts) {
          if (scheduled) return;
          var added = false;
          for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { added = true; break; } }
          if (!added) return;
          scheduled = true;
          requestAnimationFrame(function () { scheduled = false; process(); });
        }).observe(document.body, { childList: true, subtree: true });
      }

      // ---------------------------------------------------------------------
      // Colour-group resolution (SA Variants / Variant King "combined listing")
      //
      // Every colour of a product line is a SEPARATE Shopify product, grouped by
      // the app. This used to read ONE app global -- starapps_vkcl_data.product_groups.
      // App v2.17 renamed that global AND changed its shape, which silently emptied
      // the drawer's colour row store-wide (and killed the sibling prefetch, so
      // colour switching went slow too). Resolution is now LAYERED and never
      // depends on a single source; the first layer that answers wins:
      //   1. the card's own already-rendered app swatches -- instant, zero network,
      //      and the only layer that works on the HOME page (the app's snapshot
      //      global is {} there because its build pass throws, yet it still injects
      //      every swatch into the DOM)
      //   2. the app's runtime snapshot   (__vkclPageGroupSnapshot, collection pages)
      //   3. the app's inline settings blob (vkcl_data() / vkclData)
      //   4. Shopify itself -- siblings share an identical product title, so
      //      /search/suggest.json with fields=title returns the group with no app
      //      involved at all. Survives the app being updated, broken or uninstalled.
      // Labels come from the sibling's own /products/{h}.js; swatch images come from
      // the app's hidden per-card image block when present (zero requests), else from
      // that same JSON. The feed carries neither in v2.17.
      // ---------------------------------------------------------------------

      // Every app data global that might be present, richest first. As of app v2.17
      // the real group data is on __vkclPageGroupSnapshot; starapps_vkcl_data (which
      // this drawer used to be built on) is NEVER defined any more.
      _feeds() {
        var out = [];
        if (window.__vkclPageGroupSnapshot) out.push({ collection_group_data: window.__vkclPageGroupSnapshot });
        try { if (typeof window.vkcl_data === 'function') { var d = window.vkcl_data(); if (d) out.push(d); } } catch (e) {}
        if (window.vkclData) out.push(window.vkclData);
        if (window.starapps_vkcl_data) out.push(window.starapps_vkcl_data);
        return out;
      }

      // Layer 1: the swatches the app has ALREADY rendered onto this card. Each one
      // carries swatch-url="/products/{handle}", so the card is a complete, live,
      // zero-latency copy of the colour group -- including on templates where the
      // app's own data globals are empty.
      _groupFromCard(card, handle) {
        if (!card || card === document) return [];
        var out = [];
        card.querySelectorAll('[swatch-url]').forEach(function (el) {
          var h = hOf(el.getAttribute('swatch-url'));
          if (h && out.indexOf(h) === -1) out.push(h);
        });
        if (out.length && out.indexOf(handle) === -1) out.unshift(handle);
        return out.length > 1 ? out : [];
      }

      // The app also stashes each sibling's imagery in a hidden per-card block. Using it
      // means every colour swatch paints on the first frame with no requests at all.
      _cardImageMap(card) {
        var map = {};
        if (!card || card === document) return map;
        card.querySelectorAll('[data-product-handle][data-featured-image]').forEach(function (el) {
          var h = el.getAttribute('data-product-handle'), src = el.getAttribute('data-featured-image');
          if (h && src && !map[h]) map[h] = src;
        });
        return map;
      }

      // v2.17 groups: [{ products: [{handle, published, product_position}] }]
      _handlesFromGroups(groups) {
        var rows = [];
        (groups || []).forEach(function (g) {
          (((g || {}).products) || []).forEach(function (p) {
            if (!p || !p.handle || p.published === false) return;
            rows.push({ h: p.handle, pos: typeof p.product_position === 'number' ? p.product_position : 9999 });
          });
        });
        rows.sort(function (a, b) { return a.pos - b.pos; });
        var out = [];
        rows.forEach(function (r) { if (out.indexOf(r.h) === -1) out.push(r.h); });
        return out;
      }

      // Layers 2 + 3: the app's own feed, in either shape.
      _groupFromFeeds(handle) {
        var feeds = this._feeds();
        for (var f = 0; f < feeds.length; f++) {
          var d = feeds[f] || {};

          // v2.17, collection / index templates: keyed by handle
          var cg = d.collection_group_data;
          if (cg && cg[handle] && cg[handle].groups) {
            var a = this._handlesFromGroups(cg[handle].groups);
            if (a.length > 1) return a;
          }

          // v2.17, product template: the current product's groups, ungrouped array
          if (d.product_group_data && d.product_group_data.length) {
            var b = this._handlesFromGroups(d.product_group_data);
            if (b.length > 1 && b.indexOf(handle) !== -1) return b;
          }

          // legacy (pre-2.17): product_groups[].option_values[]
          var og = d.product_groups || [];
          for (var i = 0; i < og.length; i++) {
            var ov = (og[i] || {}).option_values || [], mine = false, hs = [];
            for (var j = 0; j < ov.length; j++) {
              var o = ov[j];
              if (!o || !o.handle || o.published === false) continue;
              if (hs.indexOf(o.handle) === -1) hs.push(o.handle);
              if (o.handle === handle) mine = true;
            }
            if (mine && hs.length > 1) return hs;
          }
        }
        return [];
      }

      // Layer 4: no app needed. Colour siblings share an identical product title,
      // so an exact-title match against Shopify's own search suggest endpoint IS
      // the group. One request, CDN-cached, capped at the endpoint's 10 results.
      async _groupFromTitle(title, handle) {
        if (!title) return [];
        try {
          var r = await fetch('/search/suggest.json?q=' + encodeURIComponent(title) +
            '&resources[type]=product&resources[limit]=10&resources[options][fields]=title');
          var d = await r.json();
          var ps = (((d.resources || {}).results || {}).products) || [];
          var want = String(title).trim().toLowerCase();
          var out = [];
          ps.forEach(function (p) {
            if (!p || !p.handle) return;
            if (String(p.title || '').trim().toLowerCase() !== want) return;
            if (out.indexOf(p.handle) === -1) out.push(p.handle);
          });
          return out.length > 1 && out.indexOf(handle) !== -1 ? out : [];
        } catch (e) { return []; }
      }

      // The colour NAME for a sibling, from its own cached /products/{h}.js.
      _labelFor(handle) {
        var p = this._pcache[handle];
        if (!p) return '';
        var opts = p.options || [], v = (p.variants || [])[0] || {};
        for (var i = 0; i < opts.length; i++) {
          var nm = typeof opts[i] === 'string' ? opts[i] : (opts[i] || {}).name;
          if (/colou?r/i.test(nm || '')) return v['option' + (i + 1)] || '';
        }
        return '';
      }

      // The swatch image for a sibling: the app's own per-card image data first (free,
      // already in the DOM), else the sibling's featured image once its JSON lands.
      _swatchUrl(handle) {
        var src = (this._cardImgs || {})[handle];
        if (!src) {
          var p = this._pcache[handle];
          src = p && (p.featured_image || ((p.images || [])[0]));
        }
        if (!src) return '';
        // Only Shopify CDN urls take the _WxH filename resize; app-CDN urls are used as-is.
        return src.indexOf('cdn.shopify.com') !== -1 ? thumb(src, '100x100') : src;
      }

      _swatchFor(handle) {
        var src = this._swatchUrl(handle);
        if (!src) return '';
        return 'background-image:url(' + src + ');background-size:cover;background-position:center';
      }

      _buildGroup(handles, current) {
        var self = this;
        return (handles || []).map(function (h) {
          var style = self._swatchFor(h);
          return {
            handle: h,
            url: '/products/' + h,
            label: self._labelFor(h),
            style: style,
            needimg: !style,
            active: h === current
          };
        });
      }

      // Patch a swatch in place from cache once its sibling JSON is known. In-place,
      // never a re-render: re-rendering here would detach the node a click is still
      // bubbling through (see docs/gotchas.md - detached event.target).
      _paintSwatch(handle) {
        var g = (this._group || []).filter(function (x) { return x.handle === handle; })[0];
        if (!g) return;
        var src = this._swatchUrl(handle), label = this._labelFor(handle);
        if (src) { g.style = this._swatchFor(handle); g.needimg = false; }
        if (label) { g.label = label; }
        var el = this.querySelector('.qcd-swatch[data-h="' + handle + '"]');
        if (!el) return;
        if (src) {
          el.style.backgroundImage = 'url(' + src + ')';
          el.style.backgroundSize = 'cover';
          el.style.backgroundPosition = 'center';
          el.removeAttribute('data-needimg');
        }
        if (label) {
          el.setAttribute('title', label);
          el.setAttribute('data-label', label);
          if (g.active) {
            var nameEl = this.querySelector('.qcd-color-name');
            if (nameEl && !nameEl.textContent.trim()) nameEl.textContent = label;
          }
        }
      }

      // Repaint every swatch from what is already cached. Cache-only on purpose: this runs
      // on EVERY _renderOpts (i.e. every size tap), so it must never start a request --
      // fetching is _prefetchGroup's job and it de-dupes.
      _fillSwatchImages() {
        var self = this;
        (this._group || []).forEach(function (g) {
          if (g && g.handle && self._pcache[g.handle]) self._paintSwatch(g.handle);
        });
      }

      // The product card that owns a quick-add trigger. `closest` with a selector LIST
      // returns the nearest ancestor matching ANY selector, so the app-stamped
      // <product-card> has to be asked for on its own or an inner <li> would win and the
      // card's swatches/stamp would sit outside the element we scope our queries to.
      _cardOf(btn) {
        return btn.closest('product-card') ||
          btn.closest('[sa-groups-generated]') ||
          btn.closest('.card-product, .product-card, .card, .grid__item, li') ||
          document;
      }

      // WHICH colour is the shopper actually looking at on this card?
      // data-product-url is baked into the markup at render time and the SA Variants app
      // never touches it -- so once the shopper picked a different colour on the card, the
      // trigger still pointed at the ORIGINAL product. The drawer then opened on the wrong
      // colour AND its Add-to-bag carried the wrong variant id, i.e. the shopper could add
      // a colour they never chose. Read the card's live state instead; the baked attribute
      // is only the last resort.
      _displayedHandle(btn, card) {
        var baked = hOf(btn.dataset.productUrl || '');
        if (!card || card === document) return baked;

        // 1. the app stamps the card with the handle it is currently displaying, and
        //    updates it on every colour switch. This is its own "done switching" signal.
        var stamped = card.getAttribute && card.getAttribute('sa-groups-generated');
        if (!stamped) {
          var host = card.querySelector && card.querySelector('[sa-groups-generated]');
          stamped = host && host.getAttribute('sa-groups-generated');
        }
        if (stamped && this._known(stamped)) return stamped;

        // 2. the card's main product link -- the app rewrites its href on a colour switch.
        //    Skip anything inside the app's own swatch widget: those point at SIBLING
        //    colours, so picking one up here would open a colour nobody selected.
        var links = card.querySelectorAll(
          'a[data-product-link][href*="/products/"], .card-product__link[href*="/products/"], ' +
          '.product-card__link[href*="/products/"], a[href*="/products/"]'
        );
        for (var i = 0; i < links.length; i++) {
          var a = links[i];
          if (a.closest('variant-king-combined-listing, [swatch-url], .swatches, .swatch-view')) continue;
          var h = hOf(a.getAttribute('href') || '');
          if (h) return h;
        }

        return baked;
      }

      // A stamped value is only trusted if it looks like a handle (never a blank/flag value).
      _known(h) { return !!h && /^[a-z0-9][a-z0-9-]*$/i.test(h); }

      async _load(btn) {
        var card = this._cardOf(btn);
        var handle = this._displayedHandle(btn, card);
        if (!handle) return;
        var url = '/products/' + handle;

        // Sibling imagery the app already put in the DOM -- lets every swatch paint on the
        // first frame instead of after a round of /products/{h}.js fetches.
        this._cardImgs = this._cardImageMap(card);

        // Colour group, cheapest layer first. The title layer needs the product JSON, so it
        // runs AFTER the drawer is on screen (_augmentFromTitle) -- opening never waits on it.
        var handles = this._groupFromCard(card, handle);
        if (handles.length < 2) handles = this._groupFromFeeds(handle);

        btn.classList.add('is--loading');
        try {
          var p = this._pcache[handle];
          if (!p) {
            var r = await fetch(url + '.js');
            p = await r.json();
            this._pcache[handle] = p; // cache the primary too (siblings may switch back to it)
          }
          this._group = this._buildGroup(handles, handle);
          // Fire-and-forget: warm each sibling colour's /products/{h}.js into pcache so a later
          // swatch tap swaps instantly. Additive; a cache miss still falls through to _loadUrl.
          this._prefetchGroup(handle);
          await (window.scheduler && scheduler.yield ? scheduler.yield() : new Promise(function(resolve){setTimeout(resolve,0)}));
          this._setProduct(p);
          this._draw();
          this.open();
          if (handles.length < 2) this._augmentFromTitle(p, handle);
        } catch (e) { /* silent */ }
        finally { btn.classList.remove('is--loading'); }
      }

      // Last-resort group lookup, run AFTER the drawer is open so it costs no open-latency.
      // Repaints the colour row only if the drawer is still showing the same product.
      async _augmentFromTitle(p, handle) {
        var handles = await this._groupFromTitle(p && p.title, handle);
        if (handles.length < 2) return;
        if (!this.toggleState || !this._product || this._product.handle !== handle) return;
        this._group = this._buildGroup(handles, handle);
        this._prefetchGroup(handle);
        this._syncOpts(); // rebuilds only because the group changed shape; never a blind teardown
      }

      // Warm sibling colour products (parsed /products/{h}.js) into pcache, and paint each
      // swatch's image + colour name the moment its JSON lands. Skips the current handle
      // (already fetched by _load) and anything already cached. Best-effort, never blocks.
      _prefetchGroup(current) {
        var self = this;
        this._inflight = this._inflight || {};
        (this._group || []).forEach(function (g) {
          if (!g || !g.handle) return;
          if (self._pcache[g.handle]) { self._paintSwatch(g.handle); return; }
          if (g.handle === current || self._inflight[g.handle]) return;
          self._inflight[g.handle] = 1;
          fetch('/products/' + g.handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) { self._pcache[g.handle] = p; self._paintSwatch(g.handle); })
            .catch(function () {})
            .then(function () { delete self._inflight[g.handle]; });
        });
      }

      // Load a sibling group product into the open drawer (color switch).
      // Sequenced: tapping colour A then B before A resolves used to be last-writer-wins, so a
      // slow A could land AFTER B and leave the drawer on a colour the shopper had already
      // moved off. Every call takes a ticket and a stale one bails at each await point.
      async _loadUrl(url) {
        var handle = hOf(url);
        if (!handle) return;
        var seq = (this._seq = (this._seq || 0) + 1);
        try {
          // Instant path: reuse the prefetched sibling JSON if present; else fetch (and cache) as before.
          var p = this._pcache[handle];
          if (!p) {
            var r = await fetch('/products/' + handle + '.js');
            p = await r.json();
            this._pcache[handle] = p;
            if (seq !== this._seq) return; // superseded by a newer tap
          }
          await (window.scheduler && scheduler.yield ? scheduler.yield() : new Promise(function(resolve){setTimeout(resolve,0)}));
          if (seq !== this._seq) return;   // superseded by a newer tap
          this._setProduct(p);
          this._group.forEach(function (g) { g.active = g.handle === handle; });
          this._paint();
        } catch (e) { /* silent */ }
      }

      _setProduct(p) {
        this._product = p;
        this._owv = buildOWV(p);
        this._sel = this._owv.map(function (_, i) { return p.variants[0] ? (p.variants[0]['option' + (i + 1)] || '') : ''; });
      }

      _activeVariant() {
        var o = this._sel, p = this._product;
        return p.variants.find(function (v) {
          return v.option1 === o[0] &&
            (p.options.length < 2 || v.option2 === o[1]) &&
            (p.options.length < 3 || v.option3 === o[2]);
        }) || p.variants[0];
      }

      _draw() {
        var self = this, p = this._product, v = this._activeVariant(), c = this._cfg;
        var imgSrc = thumb(v.featured_image ? v.featured_image.src : p.featured_image, '160x160');
        var pr = money(v.price != null ? v.price : p.price, c.moneyFormat);
        var cp = v.compare_at_price > v.price ? money(v.compare_at_price, c.moneyFormat) : null;
        var avail = !!v.available;
        // #1 OOS consistency: never show a dead grey "Sold out" button. When the selected
        // variant is unavailable the CTA becomes a clickable NOTIFY ME that routes to the PDP
        // (#notify), where mavin-notify auto-opens the Omnisend back-in-stock form. Same black
        // button footprint, just a different label + action.
        var addLbl = avail ? (c.addToCart || 'Add to cart') : (c.notify || 'Notify me');

        this._main.innerHTML =
          '<div class="qcd-row">' +
            '<div class="qcd-thumb">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" width="80" height="80">' : '') + '</div>' +
            '<div class="qcd-meta">' +
              '<p class="qcd-title">' + esc(p.title) + '</p>' +
              '<p class="qcd-price">' + (cp ? '<s>' + cp + '</s> ' : '') + pr + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="qcd-opts"></div>' +
          '<div class="qcd-actions">' +
            '<button type="button" class="qcd-add" data-vid="' + (v.id || '') + '">' + addLbl + '</button>' +
            '<a href="' + esc(p.url) + '" class="qcd-view">' + (c.viewProduct || 'View full product') + '</a>' +
          '</div>';

        this._renderOpts();
        // No .qcd-add listener here -- _wireMain() delegates it. Binding it again would run
        // _addToCart twice per tap and add TWO units to the cart.
      }

      _renderOpts() {
        var self = this, p = this._product;
        var container = this._main.querySelector('.qcd-opts');
        if (!container) return;

        var hasGroup = self._group && self._group.length > 1;
        var rows = [];

        // Top color row sourced from the grouped sibling products (SA Variants).
        if (hasGroup) {
          var cur = self._group.filter(function (g) { return g.active; })[0];
          // Robust current-color NAME: prefer the active group member's label, else fall back to the
          // loaded product's own color option value. (The active flag can miss when the card handle and
          // the app-feed handle differ slightly -> that showed an empty "COLOR:" with no name.)
          var prodColor = '';
          self._owv.forEach(function (o, oi) { if (/color|colour/i.test(o.name)) { prodColor = self._sel[oi] || (o.values && o.values[0]) || ''; } });
          var curColor = prodColor || (cur && cur.label) || '';
          var swatches = self._group.map(function (g) {
            return '<button type="button" class="qcd-swatch' + (g.active ? ' sel' : '') + '" data-url="' + esc(g.url) + '" data-label="' + esc(g.label) + '" data-h="' + esc(g.handle) + '"' + (g.needimg ? ' data-needimg="1"' : '') + ' title="' + esc(g.label) + '" style="' + g.style + '"></button>';
          }).join('');
          rows.push('<div class="qcd-opt"><p class="qcd-opt-lbl">Color: <strong class="qcd-color-name">' + esc(curColor) + '</strong></p><div class="qcd-opt-vals">' + swatches + '</div></div>');
        }

        self._owv.forEach(function (opt, idx) {
          var isColor = /color|colour/i.test(opt.name);
          // When the group row is shown, skip the loaded product's redundant single-value color option.
          if (hasGroup && isColor && opt.values.length <= 1) return;

          var sel = self._sel[idx];
          var btns = opt.values.map(function (val) {
            var avail = p.variants.some(function (v) { return v['option' + (idx + 1)] === val && v.available; });
            var isSel = val === sel;
            if (isColor) {
              var style = self._swatchStyle(val, p.variants);
              return '<button type="button" class="qcd-swatch' + (isSel ? ' sel' : '') + (avail ? '' : ' oos') + '" data-i="' + idx + '" data-v="' + esc(val) + '" title="' + esc(val) + '" style="' + style + '"></button>';
            }
            return '<button type="button" class="qcd-pill' + (isSel ? ' sel' : '') + (avail ? '' : ' oos') + '" data-i="' + idx + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('');
          // In-stock (green) / Sold-out (red) word for the SELECTED size, matching the PDP. Updates on
          // every size tap (this re-renders) and shows on open for the pre-selected size.
          var statusHtml = '';
          if (!isColor && sel) {
            var selAvail = p.variants.some(function (v) { return v['option' + (idx + 1)] === sel && v.available; });
            statusHtml = ' <span class="qcd-size-status qcd-size-status--' + (selAvail ? 'in' : 'out') + '">' + (selAvail ? 'In stock' : 'Sold out') + '</span>';
          }
          rows.push('<div class="qcd-opt"><p class="qcd-opt-lbl">' + esc(opt.name) + ': <strong>' + esc(sel) + '</strong>' + statusHtml + '</p><div class="qcd-opt-vals">' + btns + '</div></div>');
        });

        container.innerHTML = rows.join('');
        container.setAttribute('data-sig', self._optsSig());
        self._fillSwatchImages();
        // No per-button listeners here on purpose -- clicks are delegated once in _wireMain().
      }

      // The identity of the CURRENT option layout: which rows exist and which values each
      // holds. If this is unchanged, _syncOpts can patch classes/labels in place instead of
      // rebuilding, which is what keeps a fast tap alive (see _syncOpts).
      _optsSig() {
        var self = this, hasGroup = self._group && self._group.length > 1, sigs = [];
        if (hasGroup) { sigs.push('G|' + self._group.map(function (g) { return g.handle; }).join(',')); }
        self._owv.forEach(function (opt, idx) {
          var isColor = /color|colour/i.test(opt.name);
          if (hasGroup && isColor && opt.values.length <= 1) return;
          sigs.push(idx + '|' + opt.name + '|' + opt.values.join(','));
        });
        return sigs.join('||');
      }

      // Patch the option rows IN PLACE. This exists because rebuilding them with innerHTML on
      // every tap silently swallowed fast taps: on touch a click is only dispatched when
      // pointerdown and pointerup land on the SAME element, so replacing the button under the
      // finger mid-tap means the browser fires no click at all -- the shopper taps and nothing
      // happens, then taps again and it works. Nothing is destroyed here, so the tap survives.
      // Falls back to a full render only when the layout genuinely changed shape.
      _syncOpts() {
        var self = this, p = this._product;
        var container = this._main.querySelector('.qcd-opts');
        if (!container) return;
        if (container.getAttribute('data-sig') !== self._optsSig()) { self._renderOpts(); return; }

        if (self._group && self._group.length > 1) {
          var active = self._group.filter(function (g) { return g.active; })[0];
          container.querySelectorAll('.qcd-swatch[data-h]').forEach(function (el) {
            el.classList.toggle('sel', !!active && el.getAttribute('data-h') === active.handle);
          });
          var prodColor = '';
          self._owv.forEach(function (o, oi) { if (/color|colour/i.test(o.name)) { prodColor = self._sel[oi] || (o.values && o.values[0]) || ''; } });
          var nm = prodColor || (active && active.label) || '';
          var nameEl = container.querySelector('.qcd-color-name');
          if (nameEl && nm) { nameEl.textContent = nm; }
        }

        self._owv.forEach(function (opt, idx) {
          var sel = self._sel[idx], isColor = /color|colour/i.test(opt.name);
          var btns = container.querySelectorAll('[data-i="' + idx + '"]');
          if (!btns.length) return;
          btns.forEach(function (el) {
            var val = el.getAttribute('data-v');
            var avail = p.variants.some(function (v) { return v['option' + (idx + 1)] === val && v.available; });
            el.classList.toggle('sel', val === sel);
            el.classList.toggle('oos', !avail);
          });
          var row = btns[0].closest('.qcd-opt');
          if (!row) return;
          var strong = row.querySelector('.qcd-opt-lbl strong');
          if (strong && !strong.classList.contains('qcd-color-name')) { strong.textContent = sel; }
          var st = row.querySelector('.qcd-size-status');
          if (st && !isColor && sel) {
            var selAvail = p.variants.some(function (v) { return v['option' + (idx + 1)] === sel && v.available; });
            st.textContent = selAvail ? 'In stock' : 'Sold out';
            st.className = 'qcd-size-status qcd-size-status--' + (selAvail ? 'in' : 'out');
          }
        });

        self._fillSwatchImages();
      }

      // Patch the header row + actions in place (title, thumb, price, CTA, view link) and sync
      // the options. Used for a colour switch so the swatch row is never torn down under the
      // finger; falls back to a full _draw() if the shell isn't there yet.
      _paint() {
        var p = this._product, v = this._activeVariant(), c = this._cfg;
        if (!this._main.querySelector('.qcd-row') || !this._main.querySelector('.qcd-opts')) { this._draw(); return; }

        var imgSrc = thumb(v.featured_image ? v.featured_image.src : p.featured_image, '160x160');
        var th = this._main.querySelector('.qcd-thumb img');
        if (th && imgSrc) { th.src = imgSrc; th.alt = p.title || ''; }
        var t = this._main.querySelector('.qcd-title');
        if (t) { t.textContent = p.title || ''; }

        var pr = money(v.price != null ? v.price : p.price, c.moneyFormat);
        var cp = v.compare_at_price > v.price ? money(v.compare_at_price, c.moneyFormat) : null;
        var pel = this._main.querySelector('.qcd-price');
        if (pel) { pel.innerHTML = (cp ? '<s>' + cp + '</s> ' : '') + pr; }

        var addBtn = this._main.querySelector('.qcd-add');
        if (addBtn) {
          addBtn.disabled = false; // OOS is a clickable NOTIFY ME, never a disabled button
          addBtn.dataset.vid = v.id || '';
          addBtn.textContent = v.available ? (c.addToCart || 'Add to cart') : (c.notify || 'Notify me');
        }
        var view = this._main.querySelector('.qcd-view');
        if (view) { view.setAttribute('href', p.url || ''); }

        this._syncOpts();
      }

      _refresh() {
        var v = this._activeVariant(), c = this._cfg, p = this._product;
        var imgSrc = thumb(v.featured_image ? v.featured_image.src : p.featured_image, '160x160');
        if (imgSrc) { var th = this._main.querySelector('.qcd-thumb img'); if (th) th.src = imgSrc; }

        var pr = money(v.price != null ? v.price : p.price, c.moneyFormat);
        var cp = v.compare_at_price > v.price ? money(v.compare_at_price, c.moneyFormat) : null;
        var pel = this._main.querySelector('.qcd-price');
        if (pel) pel.innerHTML = (cp ? '<s>' + cp + '</s> ' : '') + pr;

        var addBtn = this._main.querySelector('.qcd-add');
        if (addBtn) {
          addBtn.disabled = false; // OOS is now a clickable NOTIFY ME, never a disabled button
          addBtn.dataset.vid = v.id;
          addBtn.textContent = v.available ? (c.addToCart || 'Add to cart') : (c.notify || 'Notify me');
        }
        this._syncOpts();
      }

      _swatchStyle(name, variants) {
        var match = variants.find(function (v) {
          return v.option1 === name || v.option2 === name || v.option3 === name;
        });
        if (match && match.featured_image && match.featured_image.src) {
          return 'background-image:url(' + thumb(match.featured_image.src, '100x100') + ');background-size:cover;background-position:center';
        }
        var key = name.toLowerCase();
        var hex = COLOR_MAP[key] || COLOR_MAP[key.replace(/ /g, '')] || '#ccc';
        return 'background:' + hex;
      }

      _goNotify(v) {
        // Route to the PDP's back-in-stock flow (Omnisend's widget is PDP-scoped). Signal intent
        // via sessionStorage (survives same-tab nav; immune to URL hash/query stripping by the
        // preview redirect or canonical-URL cleanup); keep #notify as a harmless backup.
        var p = this._product;
        try { sessionStorage.setItem('mavin_notify_open', '1'); } catch (e) {}
        var url = (p && p.url ? p.url : location.pathname) + (v && v.id ? '?variant=' + v.id : '') + '#notify';
        window.location.href = url;
      }

      async _addToCart() {
        var v = this._activeVariant();
        if (!v || !v.available) { this._goNotify(v); return; }
        var btn = this._main.querySelector('.qcd-add');
        var c = this._cfg;
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        try {
          // Ask for the native cart-drawer sections so we can re-render + POP the drawer and
          // refresh the counters right after the add (matches ProductForm's success path).
          var drawer = document.querySelector('cart-drawer');
          var sections = [];
          try {
            if (drawer && typeof drawer.getSectionsToRender === 'function') {
              sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
            }
          } catch (e0) {}
          var addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1, sections: sections, sections_url: window.location.pathname })
          });
          var added = await addRes.json();
          if (added && added.status) {
            // add failed (e.g. sold out) - keep the picker open and restore the button
            if (btn) { btn.disabled = false; btn.textContent = c.addToCart || 'Add to cart'; }
            return;
          }
          // Close the size-picker first so the cart drawer is not stacked behind it, then render
          // the fresh sections (this also opens the drawer and updates the header + title counters).
          this.close();
          if (drawer && typeof drawer.renderContents === 'function' && added && added.sections) {
            drawer.renderContents(added);
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
          if (typeof updateCartCounters === 'function') { updateCartCounters(); }
          if (typeof updateFreeShipping === 'function') { updateFreeShipping(); }
          // Legacy hooks kept for any listeners on the old event / counter attribute.
          try {
            var cartRes = await fetch('/cart.js');
            var cart = await cartRes.json();
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
          } catch (e2) {}
        } catch (e) {
          if (btn) { btn.disabled = false; btn.textContent = c.addToCart || 'Add to cart'; }
        }
      }

      open() {
        var self = this;
        this.toggleState = true;
        this.classList.add('is--open');
        document.body.classList.add('overflow-hidden');
        if (this._panel) {
          this._panel.setAttribute('tabindex', '0');
          setTimeout(function() { if (self._panel) self._panel.focus({ preventScroll: true }); }, 50);
        }
      }

      close() {
        if (!this.toggleState) return;
        this.toggleState = false;
        this.classList.remove('is--open');
        document.body.classList.remove('overflow-hidden');
      }
    }

    customElements.define('quick-cart-drawer', QuickCartDrawer);
  }
})();
